import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Router, ActivatedRoute } from '@angular/router';
// import { default as swal } from 'sweetalert2';
import { environment } from '../environments/environment';
import { SocketService } from './socket.service';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { StorageService } from './storage.service';

// import { Observable,Observer } from 'rxjs';
// import * as socketIo from 'socket.io-client';
// import { Socket} from './interfaces';
// import { tokenNotExpired } from 'angular2-jwt';
declare var toastr, $, download, notifier;
var authToken;
var options;
@Injectable()
export class AuthService {

  domain = environment.apiURL;
  domain2 = environment.apiURL2;

  private simpleVar: any = 0;
  private $BehaveObs: BehaviorSubject<any>;


  constructor(private storage: StorageService, private http: HttpClient, private router: Router, private socket: SocketService) {
    this.$BehaveObs = new BehaviorSubject(this.simpleVar);
    // console.log(this.$BehaveObs);
  }

  //#region Authentication
  createAuthenticationHeaders() {
    let uri = window.location.search
    if (window.location.href.includes('mapview')) {
      return {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6eyJwZXJtaXNzaW9uIjp7ImNyZWF0ZUFkbWluIjpmYWxzZSwibGFuZU9ubHkiOmZhbHNlLCJjcmVhdGVCYXNlIjpmYWxzZSwiY3JlYXRlR3JpZCI6ZmFsc2UsInJlcG9ydHMiOnRydWUsImFkZExvY2F0aW9uIjpmYWxzZSwiZWRpdEFkbWluIjpmYWxzZSwidmlld0FkbWluIjp0cnVlLCJjcmVhdGVTdWJBZG1pbiI6dHJ1ZSwiZWRpdFN1YkFkbWluIjp0cnVlLCJjcmVhdGVTdWJBZG1pblVzZXJzIjp0cnVlLCJlZGl0U3ViQWRtaW5Vc2VycyI6dHJ1ZSwibWFwVmlldyI6dHJ1ZSwiY29udGFpbmVyU3RhdHVzRGFzaGJvYXJkIjp0cnVlLCJ1cGxvYWRDb250YWluZXJzIjp0cnVlLCJlZGl0Q29udGFpbmVycyI6dHJ1ZSwibm90aWZpY2F0aW9uU2V0dGluZyI6dHJ1ZSwiYW5hbHl0aWNzIjp0cnVlLCJlcXVpcG1lbnRBbGxvY2F0aW9uIjp0cnVlLCJlZGl0RXF1aXBtZW50Ijp0cnVlLCJsYW5lQWxsb2NhdGlvbiI6dHJ1ZSwiY3JlYXRlR2F0ZXMiOnRydWUsImVkaXRHYXRlcyI6dHJ1ZSwiY3JlYXRlVXNlcnNHYXRlIjp0cnVlLCJlZGl0VXNlcnNHYXRlIjp0cnVlLCJhZGRBc3NldCI6dHJ1ZSwiZWRpdEFzc2V0Ijp0cnVlLCJjcmVhdGVVc2Vyc1lhcmQiOnRydWUsImVkaXRVc2Vyc1lhcmQiOnRydWUsImNyZWF0ZVVzZXJzQ3JhbmUiOnRydWUsImVkaXRVc2Vyc0NyYW5lIjp0cnVlLCJzd2l0Y2hKb2JzIjpmYWxzZSwibWFudWFsQWRkcmVzcyI6ZmFsc2UsIm1hcE9wZXJhdG9yIjpmYWxzZSwic2VhcmNoQ29udGFpbmVyIjpmYWxzZSwiYXV0b21hdGljWWFyZCI6ZmFsc2UsImFjY2VwdFRhc2siOmZhbHNlLCJhdXRvbWF0aWNDcmFuZSI6ZmFsc2UsInJlamVjdFRhc2siOmZhbHNlLCJlbXB0eVRyYWlsZXJFZGl0IjpmYWxzZSwiYWxsb2NHYXRlIjpmYWxzZSwiY3JlYXRlQ0hBSm9iIjpmYWxzZSwidmlld0NIQUpvYiI6ZmFsc2UsInZpZXdIZWF0TWFwIjp0cnVlLCJkb3dubG9hZCI6dHJ1ZSwidmlld0Fzc2V0Ijp0cnVlLCJhZGRsb2NhdGlvbiI6dHJ1ZSwiam9icyI6dHJ1ZSwiaGVpZ2h0U2hpZnRpbmciOnRydWUsImdyaWRTaGlmdGluZyI6dHJ1ZX0sIl9pZCI6IjYyNGU4NTNiMjE2ODY3NjIzYWFmMDY3OSIsImVtYWlsIjoiZGVtb0BseW5raXQuaW4iLCJtb2JpbGUiOiI5MjQwMjkyMDA5IiwiZGVwb3ROYW1lIjpbIkxhbmRtYXJrIENGUyJdLCJkZXBvdElEIjpbIjYwZDg4NjgwNTIwNGM0MzY2NGEzYjgwOCJdLCJwb3NpdGlvbiI6W10sInVzZXJUeXBlIjoiYWRtaW4iLCJuYW1lIjoiTHlua2l0IEFkbWluIiwic3RhdHVzIjoiQSIsImlzQXBwcm92ZWQiOnRydWUsInNlc3Npb25LZXkiOiIxNjc1ODM5MTA4NzQ3XzYyNGU4NTNiMjE2ODY3NjIzYWFmMDY3OV9kZW1vQGx5bmtpdC5pbiJ9LCJpYXQiOjE2NzU4MzkxMDgsImV4cCI6MTczODk1MzAxMn0.TFGQSNcHn5PlJSsID2nOnZyunGZhIP8vgQRWzS-qe9w", agent: 'web', 'selectedYard': localStorage.getItem('selectedYard') || '', 'yardID': localStorage.getItem('yardID') || '' })
      }
    } else if (window.location.href.includes('focusview')) {

      var url = decodeURI(uri.split('&')[4].replace('=', ':'));

      if (url.includes('token')) {
        url = url.replace("token:", "")
      }

      // console.log(url);


      return {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': url, agent: 'web', 'selectedYard': localStorage.getItem('selectedYard') || '', 'yardID': localStorage.getItem('yardID') || '' })
      }

    }
    return {

      // environment.sso_token
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': localStorage.getItem(environment.auth_token), agent: 'web', 'selectedYard': localStorage.getItem('selectedYard') || '', 'yardID': localStorage.getItem('yardID') || '' })
    }
  }

  login(details) {
    return this.http.post(`${this.domain}users/login`, details)
  }

  // forgetPassword(details) {
  //   details.bgColor = `#FF5722`
  //   return this.http.post(`${this.domain}users/forgetPassword`, details)
  // }

  forgetPassword(details) {
    details.bgColor = `#FF5722`
    return this.http.post(`${this.domain}users/forgetPasswordSSO`, details)
  }

  setNewPasswordSSO(details) {
    details.bgColor = `#FF5722`
    return this.http.post(`${this.domain}users/setNewPasswordSSO`, details)
  }

  logout() {
    // let token;
    // if (localStorage.getItem('chat')) {
    //   localStorage.removeItem('chat');
    // }
    // if (localStorage.getItem(environment.auth_token)) {
    //   token = JSON.parse(atob((localStorage.getItem(environment.auth_token)).split('.')[1])).token;
    //   console.log("logout session key", token.sessionKey);
    //   this.socket.logout(token._id, token.sessionKey)

    // }
    // authToken = null;
    // localStorage.removeItem(environment.auth_token);
    // localStorage.removeItem('selectedYard');
    // localStorage.removeItem('yardID');
    // this.router.navigate(['/login'])
    let token;

    if (localStorage.getItem('chat')) {
      localStorage.removeItem('chat');
    }
    if (localStorage.getItem(environment.auth_token) && localStorage.getItem('sessionKey')) {
      token = localStorage.getItem(environment.auth_token);
      console.log("logout session key", localStorage.getItem('sessionKey'));
      this.socket.logout(token._id, localStorage.getItem('sessionKey'))
    }
    authToken = null;
    localStorage.removeItem(environment.auth_token);
    localStorage.removeItem('sessionKey');
    localStorage.removeItem('selectedYard');
    localStorage.removeItem('yardID');
    // localStorage.removeItem('theme');
    this.router.navigate(['/login'])
  }

  changePassword(details) {
    return this.http.post(`${this.domain}users/changePasswordSSO`, details, this.createAuthenticationHeaders())
  }

  // changePassword(details) {
  //   return this.http.post(`${this.domain}users/changePassword`, details, this.createAuthenticationHeaders())
  // }

  checkEncryptedString(details) {
    return this.http.post(`${this.domain}users/checkEncryptedString`, details)
  }

  updateUser(details) {
    return this.http.post(`${this.domain}users/updateUser`, details, this.createAuthenticationHeaders())
  }

  // setNewPassword(details) {
  //   return this.http.post(`${this.domain}users/setNewPassword`, details)
  // }

  setNewPassword(details) {
    return this.http.post(`${this.domain}users/setNewPasswordSSO`, details)
  }

  getLocation(details) {
    return this.http.post(`${this.domain}redis/getLocation`, details, this.createAuthenticationHeaders())
  }

  liveLocationOfCrane(details) {
    details['selectedYard'] = localStorage.getItem('selectedYard')
    details['yardID'] = localStorage.getItem('yardID');
    return this.http.post(`${this.domain}crane/liveLocationOfCrane`, details, this.createAuthenticationHeaders())
  }

  query(details) {
    return this.http.post(`${this.domain}query`, details, this.createAuthenticationHeaders())
  }

  trackContainer(details) {
    details['selectedYard'] = localStorage.getItem('selectedYard')
    details['yardID'] = localStorage.getItem('yardID');
    return this.http.post(`${this.domain}container/trackContainer`, details)
  }
  // #endregion Authentication

  //#region Admin
  createAdmin(details) {
    return this.http.post(`${this.domain}admin`, details, this.createAuthenticationHeaders())
  }

  getAdminNames(details) {
    return this.http.post(`${this.domain}admin/getNames`, details, this.createAuthenticationHeaders())
  }

  getAdmins(details) {
    return this.http.post(`${this.domain}admin/get`, details, this.createAuthenticationHeaders())
  }

  editAdmin(details) {
    return this.http.post(`${this.domain}admin/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusAdmin(details) {
    return this.http.post(`${this.domain}admin/changeStatus`, details, this.createAuthenticationHeaders())
  }
  //#endregion Admin

  //#region Subadmin
  createSubAdmin(details) {
    return this.http.post(`${this.domain}subadmin`, details, this.createAuthenticationHeaders())
  }

  getSubAdminNames(details) {
    return this.http.post(`${this.domain}subadmin/getNames`, details, this.createAuthenticationHeaders())
  }

  getSubAdmin(details) {
    return this.http.post(`${this.domain}subadmin/get`, details, this.createAuthenticationHeaders())
  }

  editSubAdmin(details) {
    return this.http.post(`${this.domain}subadmin/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusSubAdmin(details) {
    return this.http.post(`${this.domain}subadmin/changeStatus`, details, this.createAuthenticationHeaders())
  }
  //#endregion Subadmin


  //#region Subadmin User
  createSubUser(details) {
    return this.http.post(`${this.domain}subuser`, details, this.createAuthenticationHeaders())
  }

  getSubUserNames(details) {
    return this.http.post(`${this.domain}subuser/getNames`, details, this.createAuthenticationHeaders())
  }

  getSubUser(details) {
    return this.http.post(`${this.domain}subuser/get`, details, this.createAuthenticationHeaders())
  }

  editSubUser(details) {
    return this.http.post(`${this.domain}subuser/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusSubUser(details) {
    return this.http.post(`${this.domain}subuser/changeStatus`, details, this.createAuthenticationHeaders())
  }
  //#endregion Subadmin

  //#region Crane
  createCraneOperator(details) {
    return this.http.post(`${this.domain}crane`, details, this.createAuthenticationHeaders())
  }

  getCraneOperatorNames(details) {
    return this.http.post(`${this.domain}crane/getNames`, details, this.createAuthenticationHeaders())
  }

  getCraneOperator(details) {
    return this.http.post(`${this.domain}crane/get`, details, this.createAuthenticationHeaders())
  }

  editCraneOperator(details) {
    return this.http.post(`${this.domain}crane/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusCraneOperator(details) {
    return this.http.post(`${this.domain}crane/changeStatus`, details, this.createAuthenticationHeaders())
  }
  //#endregion Crane
  //#region users

  getUsers(details) {
    return this.http.post(`${this.domain + details.path}`, details, this.createAuthenticationHeaders())
  }

  createUser(details) {
    return this.http.post(`${this.domain + details.path}`, details, this.createAuthenticationHeaders())
  }
  editUser(details) {
    return this.http.post(`${this.domain + details.path}`, details, this.createAuthenticationHeaders())
  }

  //#endregion users

  // region rake ops
  getLoadingPlan(details) {
    return this.http.post(`${this.domain}rake/getLoadingPlan`, details, this.createAuthenticationHeaders())
  }

  getRakeList(details) {
    return this.http.post(`${this.domain}rake/getRakeList`, details, this.createAuthenticationHeaders())
  }

  markCompleted(details) {
    return this.http.post(`${this.domain}rake/markCompleted`, details, this.createAuthenticationHeaders())
  }

  assignRakeToLoadingPlan(details) {
    return this.http.post(`${this.domain}rake/assignRakeToLoadingPlan`, details, this.createAuthenticationHeaders())
  }

  getDistinctRakes(details) {
    return this.http.post(`${this.domain}rake/getDistinctRakes`, details, this.createAuthenticationHeaders())
  }
  // endregion rake ops

  //#region Gate operator
  createGateOperator(details) {
    return this.http.post(`${this.domain}gateuser`, details, this.createAuthenticationHeaders())
  }

  getGateOperatorNames(details) {
    return this.http.post(`${this.domain}gateuser/getNames`, details, this.createAuthenticationHeaders())
  }

  getGateOperator(details) {
    return this.http.post(`${this.domain}gateuser/get`, details, this.createAuthenticationHeaders())
  }

  editGateOperator(details) {
    return this.http.post(`${this.domain}gateuser/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusGateOperator(details) {
    return this.http.post(`${this.domain}gateuser/changeStatus`, details, this.createAuthenticationHeaders())
  }

  getGates(details) {
    return this.http.post(`${this.domain}gate/get`, details, this.createAuthenticationHeaders())
  }

  editGate(details) {
    return this.http.post(`${this.domain}gate/edit`, details, this.createAuthenticationHeaders());
  }

  getRequest(uri) {
    return this.http.get(`${this.domain}` + uri, this.createAuthenticationHeaders())
  }

  postRequest(uri, body) {
    return this.http.post(`${this.domain}` + uri, body, this.createAuthenticationHeaders())
  }
  //#endregion Gate In

  //#region Gate
  createGate(details) {
    return this.http.post(`${this.domain}gate`, details, this.createAuthenticationHeaders());
  }

  viewGate(details) {
    return this.http.post(`${this.domain}gate/get`, details, this.createAuthenticationHeaders());
  }

  //#endregion Gate In

  //#region Yard
  createYardOperator(details) {
    return this.http.post(`${this.domain}yard`, details, this.createAuthenticationHeaders())
  }

  getYardOperatorNames(details) {
    return this.http.post(`${this.domain}yard/getNames`, details, this.createAuthenticationHeaders())
  }

  getYardOperator(details) {
    return this.http.post(`${this.domain}yard/get`, details, this.createAuthenticationHeaders())
  }

  editYardOperator(details) {
    return this.http.post(`${this.domain}yard/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusYardOperator(details) {
    return this.http.post(`${this.domain}yard/changeStatus`, details, this.createAuthenticationHeaders())
  }

  yardAnalytics(details) {
    return this.http.post(`${this.domain}yard/yardAnalytics`, details, this.createAuthenticationHeaders())
  }

  distinctNames(details) {
    return this.http.post(`${this.domain}yard/distinctNames`, details, this.createAuthenticationHeaders())
  }

  getFixValue(details) {
    return this.http.post(`${this.domain}yard/getFixValue`, details, this.createAuthenticationHeaders())
  }

  getFixPackets(details) {
    return this.http.post(`${this.domain}yard/getFixPackets`, details, this.createAuthenticationHeaders())
  }

  getYard(details) {
    return this.http.post(`${this.domain}yard/getYard`, details, this.createAuthenticationHeaders())
  }

  setDefaultYard(details) {
    return this.http.post(`${this.domain}yard/setDefaultYard`, details, this.createAuthenticationHeaders())
  }
  //#endregion Yard

  //#region Asset
  createAsset(details) {
    return this.http.post(`${this.domain}asset`, details, this.createAuthenticationHeaders())
  }

  getAssetNames(details) {
    return this.http.post(`${this.domain}asset/getNames`, details, this.createAuthenticationHeaders())
  }

  getAsset(details) {
    return this.http.post(`${this.domain}asset/get`, details, this.createAuthenticationHeaders())
  }

  editAsset(details) {
    return this.http.post(`${this.domain}asset/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusAsset(details) {
    return this.http.post(`${this.domain}asset/changeStatus`, details, this.createAuthenticationHeaders())
  }

  getLiveData(details) {
    return this.http.post(`${this.domain}asset/getLiveData`, details, this.createAuthenticationHeaders())
  }
  
  getFirmwareVersionHistory(details) {
    return this.http.post(`${this.domain}asset/getFirmwareVersionHistory`, details, this.createAuthenticationHeaders())
  }
  //#endregion Asset

  //#region Equipment
  getImage(details) {
    return this.http.post(`${this.domain}jobs/getImage`, details, this.createAuthenticationHeaders())
  }

  minMaxCountForContainerFilters(details) {
    return this.http.post(`${this.domain}jobs/minMaxCountForContainerFilters`, details, this.createAuthenticationHeaders())
  }

  getEquipments(details) {
    return this.http.post(`${this.domain}equipment/view`, details, this.createAuthenticationHeaders())
  }

  //#endregion Equipment

  //#region Warehouse
  createWarehouseOperator(details) {
    return this.http.post(`${this.domain}warehouse`, details, this.createAuthenticationHeaders())
  }

  getWarehouseOperatorNames(details) {
    return this.http.post(`${this.domain}warehouse/getNames`, details, this.createAuthenticationHeaders())
  }

  getWarehouseOperator(details) {
    return this.http.post(`${this.domain}warehouse/get`, details, this.createAuthenticationHeaders())
  }

  editWarehouseOperator(details) {
    return this.http.post(`${this.domain}warehouse/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusWarehouseOperator(details) {
    return this.http.post(`${this.domain}warehouse/changeStatus`, details, this.createAuthenticationHeaders())
  }
  //#endregion Warehouse

  //#region Warehouse Requests
  getEmptyContainers(details) {
    return this.http.post(`${this.domain}warehouseRequests/getEmptyContainers`, details, this.createAuthenticationHeaders())
  }

  createRequest(details) {
    return this.http.post(`${this.domain}warehouseRequests`, details, this.createAuthenticationHeaders())
  }

  getWarehouseRequests(details) {
    return this.http.post(`${this.domain}warehouseRequests/get`, details, this.createAuthenticationHeaders())
  }

  getCountWarehouseRequests(details) {
    return this.http.post(`${this.domain}warehouseRequests/getCountWarehouseRequests`, details, this.createAuthenticationHeaders())
  }

  changeStatusWarehouseRequests(details) {
    return this.http.post(`${this.domain}warehouseRequests/changeStatus`, details, this.createAuthenticationHeaders())
  }
  //#endregion Warehouse Requests


  //#region Base
  createBase(details) {
    return this.http.post(`${this.domain}base`, details, this.createAuthenticationHeaders())
  }

  getPointsOnMap(details) {
    return this.http.post(`${this.domain}base/getPointsOnMap`, details, this.createAuthenticationHeaders())
  }

  getBaseNames(details) {
    return this.http.post(`${this.domain}base/getNames`, details, this.createAuthenticationHeaders())
  }

  getBase(details) {
    return this.http.post(`${this.domain}base/get`, details, this.createAuthenticationHeaders())
  }

  getBaseByCode(details) {
    return this.http.post(`${this.domain}base/getBaseByCode`, details)
  }

  getBaseNamesNoToken(details) {
    details['selectedYard'] = localStorage.getItem('selectedYard')
    details['yardID'] = localStorage.getItem('yardID');
    return this.http.post(`${this.domain}base/getNamesNoToken`, details)
  }

  getBaseNoToken(details) {
    details['selectedYard'] = localStorage.getItem('selectedYard')
    details['yardID'] = localStorage.getItem('yardID');
    return this.http.post(`${this.domain}base/getNoToken`, details)
  }

  editBase(details) {
    return this.http.post(`${this.domain}base/edit`, details, this.createAuthenticationHeaders())
  }

  deleteBase(details) {
    return this.http.post(`${this.domain}base/delete`, details, this.createAuthenticationHeaders())
  }

  deleteGrid(details) {
    return this.http.post(`${this.domain}base/deleteGrid`, details, this.createAuthenticationHeaders())
  }

  occupyContainer(details) {
    return this.http.post(`${this.domain}base/occupyContainer`, details, this.createAuthenticationHeaders())
  }

  createLaneWeb(details) {
    return this.http.post(`${this.domain}base/createLaneWeb`, details, this.createAuthenticationHeaders())
  }

  gridShift(details) {
    return this.http.post(`${this.domain}base/gridShift`, details, this.createAuthenticationHeaders())
  }

  updateEmailSms(details) {
    return this.http.post(`${this.domain}base/updateEmailSms`, details, this.createAuthenticationHeaders())
  }

  getBasePermissions(details) {
    return this.http.post(`${this.domain}base/getPermissions`, details, this.createAuthenticationHeaders())
  }

  setBasePermissions(details) {
    return this.http.post(`${this.domain}base/setPermission`, details, this.createAuthenticationHeaders())
  }
  //#endregion Base

  //#region Containers

  set setData(containerDetails) {
    this.simpleVar = containerDetails
    this.$BehaveObs.next(containerDetails);
  }

  get getData(): Observable<any> {
    return this.$BehaveObs.asObservable();
  }

  createContainers(details) {
    return this.http.post(`${this.domain}container`, details, this.createAuthenticationHeaders())
  }

  createContainers2(details) {
    return this.http.post(`${this.domain2}container`, details, this.createAuthenticationHeaders())
  }

  dataEntryForGateOut(details) {
    return this.http.post(`${this.domain}container/dataEntryForGateOut`, details, this.createAuthenticationHeaders())
  }

  dataEntryForGateOut2(details) {
    return this.http.post(`${this.domain2}container/dataEntryForGateOut`, details, this.createAuthenticationHeaders())
  }

  getContainersName(details) {
    return this.http.post(`${this.domain}container/getNames`, details, this.createAuthenticationHeaders())
  }

  addGroundingContainers(details) {
    return this.http.post(`${this.domain}container/addGroundingContainers`, details, this.createAuthenticationHeaders())
  }

  getContainersNameNoToken(details) {
    details['selectedYard'] = localStorage.getItem('selectedYard')
    details['yardID'] = localStorage.getItem('yardID');
    return this.http.post(`${this.domain}container/getNamesNoToken`, details)
  }

  getContainer(details) {
    return this.http.post(`${this.domain}container/get`, details, this.createAuthenticationHeaders())
  }

  getContainerById(details) {
    return this.http.post(`${this.domain}container/getContainerById`, details, this.createAuthenticationHeaders())
  }

  getContainerByIdNoToken(details) {
    return this.http.post(`${this.domain}container/getContainerByIdNoToken`, details)
  }

  editContainer(details) {
    return this.http.post(`${this.domain}container/edit`, details, this.createAuthenticationHeaders())
  }

  deleteContainer(details) {
    return this.http.post(`${this.domain}container/delete`, details, this.createAuthenticationHeaders())
  }

  notifyUserWithEmail(details) {
    return this.http.post(`${this.domain}container/notifyUserWithEmail`, details, this.createAuthenticationHeaders())
  }

  getYardListOfBase(details) {
    return this.http.post(`${this.domain}container/getYardListOfBase`, details, this.createAuthenticationHeaders())
  }

  addYard(details) {
    return this.http.post(`${this.domain}container/addYard`, details, this.createAuthenticationHeaders())
  }

  updateProcessType(details) {
    return this.http.post(`${this.domain}/container/updateProcessType`, details, this.createAuthenticationHeaders())
  }

  getCameraEventDetails(details) {
    return this.http.post(`${this.domain}/container/getAllCameraEventDetails`, details, this.createAuthenticationHeaders())
  }

  //#endregion Containers

  //#region Analytics

  getCountOfUserStatus(details) {
    return this.http.post(`${this.domain}analytics/getCountOfUserStatus`, details, this.createAuthenticationHeaders())
  }

  getCountOfContainerStatus(details) {
    return this.http.post(`${this.domain}analytics/getCountOfContainerStatus`, details, this.createAuthenticationHeaders())
  }

  getGraphData(details) {
    return this.http.post(`${this.domain}analytics/getGraphData`, details, this.createAuthenticationHeaders())
  }

  getTotalMovesByContainer(details) {
    return this.http.post(`${this.domain}analytics/getTotalMovesByContainer`, details, this.createAuthenticationHeaders())
  }

  getTotalDaysByContainer(details) {
    return this.http.post(`${this.domain}analytics/getTotalDaysByContainer`, details, this.createAuthenticationHeaders())
  }

  getTotalActivities(details) {
    return this.http.post(`${this.domain}analytics/getTotalActivities`, details, this.createAuthenticationHeaders())
  }

  getBaseRoverData(details) {
    return this.http.post(`${this.domain}analytics/getBaseRoverData`, details, this.createAuthenticationHeaders())
  }

  getTotalMoves(details) {
    return this.http.post(`${this.domain}analytics/getTotalMoves`, details, this.createAuthenticationHeaders())
  }

  getTotalMovingTime(details) {
    return this.http.post(`${this.domain}analytics/getTotalMovingTime`, details, this.createAuthenticationHeaders())
  }

  getTotalIdleTime(details) {
    return this.http.post(`${this.domain}analytics/getTotalIdleTime`, details, this.createAuthenticationHeaders())
  }

  craneTasks(details) {
    return this.http.post(`${this.domain}analytics/craneTasks`, details, this.createAuthenticationHeaders())
  }

  craneTime(details) {
    return this.http.post(`${this.domain}analytics/craneTime`, details, this.createAuthenticationHeaders())
  }

  // getContainerStatusData(details) {
  //   return this.http.post(`${this.domain}analytics/getContainerStatusData`, details, this.createAuthenticationHeaders())
  // }
  containerStatus(details) {
    return this.http.post(`${this.domain}analytics/containerStatus`, details, this.createAuthenticationHeaders())
  }

  craneOperatorTasks(details) {
    return this.http.post(`${this.domain}analytics/craneOperatorTasks`, details, this.createAuthenticationHeaders())
  }

  getContainerStatusPercentage(details) {
    return this.http.post(`${this.domain}analytics/getContainerStatusPercentage`, details, this.createAuthenticationHeaders())
  }

  capturedEventDateWise(details) {
    return this.http.post(`${this.domain}analytics/capturedEventDateWise`, details, this.createAuthenticationHeaders())
  }

  capturedFixsDateWise(details) {
    return this.http.post(`${this.domain}analytics/capturedFixsDateWise`, details, this.createAuthenticationHeaders())
  }

  capturedPerformanceDateWise(details) {
    return this.http.post(`${this.domain}analytics/capturedPerformanceDateWise`, details, this.createAuthenticationHeaders())
  }

  //#endregion Analytics

  //region Jobs
  manuallyLinkTID(details) {
    return this.http.post(`${this.domain}jobs/manuallyLinkTID`, details, this.createAuthenticationHeaders())
  }

  manuallyLocationFix(details) {
    return this.http.post(`${this.domain}jobs/manuallyLocationFix`, details, this.createAuthenticationHeaders())
  }

  gateOut(details) {
    return this.http.post(`${this.domain}container/gateOut`, details, this.createAuthenticationHeaders())
  }

  resetGateOutRequest(details) {
    return this.http.post(`${this.domain}container/resetGateOutRequest`, details, this.createAuthenticationHeaders())
  }

  replaceTag(details) {
    return this.http.post(`${this.domain}tags/delinkContainer`, details, this.createAuthenticationHeaders())
  }

  manuallyGateOut(details) {
    return this.http.post(`${this.domain}jobs/manuallyGateOut`, details, this.createAuthenticationHeaders())
  }

  jobAnalytics(details) {
    return this.http.post(`${this.domain}jobs/jobAnalytics`, details, this.createAuthenticationHeaders())
  }

  jobAnalyticsTypeWise(details) {
    return this.http.post(`${this.domain}jobs/jobAnalyticsTypeWise`, details, this.createAuthenticationHeaders())
  }

  jobAnalyticsInternalCraneWise(details) {
    return this.http.post(`${this.domain}jobs/jobAnalyticsInternalCraneWise`, details, this.createAuthenticationHeaders())
  }

  getAllocatedJobs(details) {
    return this.http.post(`${this.domain}jobs/getAllocatedJobs`, details, this.createAuthenticationHeaders())
  }


  //#endregion Jobs

  // #region Inventory

  uploadRfidTags(details) {
    return this.http.post(`${this.domain}tags/rfidTagsBulkUpload`, details, this.createAuthenticationHeaders())
  }

  getAllTags(details) {
    return this.http.post(`${this.domain}tags/getAllTags`, details, this.createAuthenticationHeaders())
  }

  updateTagStatus(details) {
    return this.http.post(`${this.domain}tags/updateTagStatus`, details, this.createAuthenticationHeaders())
  }

  delinkTag(details) {
    return this.http.post(`${this.domain}tags/delinkTag`, details, this.createAuthenticationHeaders())
  }

  getTagCountStatusWise(details) {
    return this.http.post(`${this.domain}tags/getTagCountStatusWise`, details, this.createAuthenticationHeaders())
  }

  getTID(details) {
    return this.http.post(`${this.domain}container/getTID`, details, this.createAuthenticationHeaders())
  }

  getUserData(details) {
    return this.http.post(`${this.domain}users/getUserDetails`, details, this.createAuthenticationHeaders())
  }

  setDefaultTheme(details) {
    return this.http.post(`${this.domain}users/setDefaultTheme`, details, this.createAuthenticationHeaders())
  }
  // #endregion Inventory


  //#region Trailer
    addTrailer(details) 
    {
      return this.http.post(`${this.domain}trailer/add`, details, this.createAuthenticationHeaders())
    }

    editTrailer(details) 
    {
      return this.http.post(`${this.domain}trailer/edit`, details, this.createAuthenticationHeaders())
    }

    getAllTrailer(details) 
    {
      return this.http.post(`${this.domain}trailer/getAllTrailer`, details, this.createAuthenticationHeaders())
    }

    deleteTrailer(details) 
    {
      return this.http.post(`${this.domain}trailer/deleteTrailer`, details, this.createAuthenticationHeaders())
    }

    getDriverDetails(details) 
    {
      return this.http.post(`${this.domain}trailer/getDriverDetails`, details, this.createAuthenticationHeaders())
    }
  //#endregion Trailer


  //#region Extras
  getColorCodes(details) {
    return this.http.post(`${this.domain}extra/getColorCodes`, details, this.createAuthenticationHeaders())
  }

  getTableColumns(details) {
    return this.http.post(`${this.domain}extra/getTableColumns`, details, this.createAuthenticationHeaders())
  }

  getGeofenceCategory(details) {
    details['selectedYard'] = localStorage.getItem('selectedYard')
    details['yardID'] = localStorage.getItem('yardID');
    return this.http.post(`${this.domain}extra/getGeofenceCategory`, details)
  }

  getGeofenceCategoryLoggedIn(details) {
    return this.http.post(`${this.domain}extra/getGeofenceCategoryLoggedIn`, details, this.createAuthenticationHeaders())
  }

  setColor(details) {
    return this.http.post(`${this.domain}extra/setColor`, details, this.createAuthenticationHeaders())
  }

  setNameForGeofence(details) {
    return this.http.post(`${this.domain}extra/setNameForGeofence`, details, this.createAuthenticationHeaders())
  }

  getHistoryData(details) {
    return this.http.post(`${this.domain}extra/getHistoryData`, details, this.createAuthenticationHeaders())
  }

  getHistoryDataFromNewTrack(details) {
    return this.http.post(`${this.domain}extra/getHistoryDataFromNewTrack`, details, this.createAuthenticationHeaders())
  }

  getEventAnalysis(details) {
    return this.http.post(`${this.domain}extra/getEventAnalysis`, details, this.createAuthenticationHeaders())
  }

  getInvalidPackets(details) {
    return this.http.post(`${this.domain}extra/getInvalidPackets`, details, this.createAuthenticationHeaders())
  }

  getRFIDMissedEvents(details) {
    return this.http.post(`${this.domain}extra/getRFIDMissedEvents`, details, this.createAuthenticationHeaders())
  }

  getOfflineData(details) {
    return this.http.post(`${this.domain}extra/getOfflineData`, details, this.createAuthenticationHeaders())
  }

  getMonitoringData(details) {
    return this.http.post(`${this.domain}extra/getMonitoringData`, details, this.createAuthenticationHeaders())
  }

  getNotifications() {
    return this.http.post(`${this.domain}extra/getNotifications`, {}, this.createAuthenticationHeaders())
  }

  setReadStatusTrue(details) {
    return this.http.post(`${this.domain}extra/setReadStatusTrue`, details, this.createAuthenticationHeaders())
  }

  getUpdateLogs(details) {
    return this.http.post(`${this.domain}extra/getUpdateLogs`, details, this.createAuthenticationHeaders())
  }

  payloadAnalytics(details) {
    return this.http.post(`${this.domain}extra/payloadAnalytics`, details, this.createAuthenticationHeaders())
  }

  getPayload(details) {
    return this.http.post(`${this.domain}extra/getPayload`, details, this.createAuthenticationHeaders())
  }

  getUserPermission(details) {
    return this.http.post(`${this.domain}extra/getUserPermission`, details, this.createAuthenticationHeaders())
  }

  addWebAPI(details) {
    return this.http.post(`${this.domain}extra/addWebAPI`, details, this.createAuthenticationHeaders())
  }
  getWebAPI(details) {
    return this.http.post(`${this.domain}extra/getWebAPI`, details, this.createAuthenticationHeaders())
  }
  getGateOutReason(details) {
    return this.http.post(`${this.domain}extra/getGateOutReason`, details, this.createAuthenticationHeaders())
  }

  getCranesWiseAntennaDetails(details) {
    return this.http.post(`${this.domain}extra/getDeviceWiseAntennaDetails`, details, this.createAuthenticationHeaders())
  }
 
  getFixreaderDetails(details) {
    return this.http.post(`${this.domain}extra/getFixreaderDetails`, details, this.createAuthenticationHeaders())
  }

  //#endregion Extras


  //#region Lane
  getLanes(details) {
    return this.http.post(`${this.domain}lane/get`, details, this.createAuthenticationHeaders())
  }

  editLane(details) {
    return this.http.post(`${this.domain}lane/edit`, details, this.createAuthenticationHeaders())
  }

  changeStatusLane(details) {
    return this.http.post(`${this.domain}lane/changeStatus`, details, this.createAuthenticationHeaders())
  }

  configureLimit(details) {
    return this.http.post(`${this.domain}lane/configureLimit`, details, this.createAuthenticationHeaders())
  }

  laneSettings(details) {
    return this.http.post(`${this.domain}lane/laneSettings`, details, this.createAuthenticationHeaders())
  }

  laneSettingsNoToken(details) {
    details['selectedYard'] = localStorage.getItem('selectedYard')
    details['yardID'] = localStorage.getItem('yardID');
    return this.http.post(`${this.domain}lane/laneSettingsNoToken`, details)
  }

  updateLaneSettings(details) {
    return this.http.post(`${this.domain}lane/updateLaneSettings`, details, this.createAuthenticationHeaders())
  }

  getLanesByType(details) {
    return this.http.post(`${this.domain}lane/getLaneSettingsByType`, details, this.createAuthenticationHeaders())
  }

  //#endregion Lane

  //#region Reports
  getContainerMovements(details) {
    return this.http.post(`${this.domain}reports/getContainerMovements`, details, this.createAuthenticationHeaders())
  }

  gateReport(details) {
    return this.http.post(`${this.domain}reports/gateReport`, details, this.createAuthenticationHeaders())
  }

  inventoryReport(details) {
    return this.http.post(`${this.domain}reports/inventoryReport`, details, this.createAuthenticationHeaders())
  }

  machineMovementReport(details) {
    return this.http.post(`${this.domain}reports/machineMovementReport`, details, this.createAuthenticationHeaders())
  }

  areaWiseReport(details) {
    return this.http.post(`${this.domain}reports/areaWiseReport`, details, this.createAuthenticationHeaders())
  }

  scheduleReportEmail(details) {
    return this.http.post(`${this.domain}reports/scheduleReportEmail`, details, this.createAuthenticationHeaders())
  }
  //#endregion Reports
  addPlaceOnMap(details) {
    return this.http.post(`${this.domain}map/addPlaceOnMap`, details, this.createAuthenticationHeaders())
  }
  dynmaicReportsData(endpoint, details) {
    return this.http.post(`${this.domain}${endpoint}`, details, this.createAuthenticationHeaders())
  }
  getReportKeys(details) {
    return this.http.post(`${this.domain}reports/getReportKeys`, details, this.createAuthenticationHeaders())
  }
  setDefaultKeys(details) {
    return this.http.post(`${this.domain}reports/setDefaultKeys`, details, this.createAuthenticationHeaders())
  }

  setLabel(details) {
    return this.http.post(`${this.domain}reports/setLabel`, details, this.createAuthenticationHeaders())
  }

  gateAnalytics(details) {
    return this.http.post(`${this.domain}analytics/gateAnalytics`, details, this.createAuthenticationHeaders())
  }

  laneTypeAnalytics(details) {
    return this.http.post(`${this.domain}analytics/laneTypeAnalytics`, details, this.createAuthenticationHeaders())
  }

  getCountOfEquipmentType(details) {
    return this.http.post(`${this.domain}analytics/getCountOfEquipmentType`, details, this.createAuthenticationHeaders())
  }

  getTagAnalytics(details) {
    return this.http.post(`${this.domain}analytics/getTagAnalytics`, details, this.createAuthenticationHeaders())
  }

  getAssetOnlineOffline(details) {
    return this.http.post(`${this.domain}analytics/getAssetOnlineOffline`, details, this.createAuthenticationHeaders())
  }

  //#region Dashboard
  getTaskDetails(details) {
    return this.http.post(`${this.domain}dashboard/getTaskDetails`, details, this.createAuthenticationHeaders())
  }

  getAvgMaxMoves(details) {
    return this.http.post(`${this.domain}dashboard/getAvgMaxMoves`, details, this.createAuthenticationHeaders())
  }

  getRecentContainersBasedOnStatus(details) {
    return this.http.post(`${this.domain}dashboard/getRecentContainersBasedOnStatus`, details, this.createAuthenticationHeaders())
  }

  getCountOfContainersBasedOnStatus(details) {
    return this.http.post(`${this.domain}dashboard/getCountOfContainersBasedOnStatus`, details, this.createAuthenticationHeaders())
  }

  getCountBasedOnProcessType(details) {
    return this.http.post(`${this.domain}dashboard/getCountBasedOnProcessType`, details, this.createAuthenticationHeaders())
  }

  getContainerTypeAnalytics(details) {
    return this.http.post(`${this.domain}dashboard/getContainerTypeAnalytics`, details, this.createAuthenticationHeaders())
  }

  getTaskGraph(details) {
    return this.http.post(`${this.domain}dashboard/getTaskGraph`, details, this.createAuthenticationHeaders())
  }

  avgMovesForAllBase(details) {
    return this.http.post(`${this.domain}dashboard/avgMovesForAllBase`, details, this.createAuthenticationHeaders())
  }

  avgMarketTrendMovesForAllBase(details) {
    return this.http.post(`${this.domain}dashboard/avgMarketTrendMovesForAllBase`, details, this.createAuthenticationHeaders())
  }

  getAllElements(details) {
    return this.http.post(`${this.domain}customdashboard/getAllElements`, details, this.createAuthenticationHeaders())
  }

  createCustomDashboard(details) {
    return this.http.post(`${this.domain}customdashboard/create`, details, this.createAuthenticationHeaders())
  }

  getCustomDashboard(details) {
    return this.http.post(`${this.domain}customdashboard/get`, details, this.createAuthenticationHeaders())
  }

  editCustomDashboard(details) {
    return this.http.post(`${this.domain}customdashboard/edit`, details, this.createAuthenticationHeaders())
  }

  deleteCustomDashboard(details) {
    return this.http.post(`${this.domain}customdashboard/delete`, details, this.createAuthenticationHeaders())
  }

  setDefaultDashboard(details) {
    return this.http.post(`${this.domain}customdashboard/setDefaultDashboard`, details, this.createAuthenticationHeaders())
  }

  getGateinGateoutCountYearly(details) {
    return this.http.post(`${this.domain}analytics/getGateinGateoutCountYearly`, details, this.createAuthenticationHeaders())
  }

  //#endregion Dashboard 

  // #region ThirdParty
  getContainerLocationFromLDB(details) {
    return this.http.post(`${this.domain}container/getContainerLocationFromLDB`, details, this.createAuthenticationHeaders())
  }

  getContainerVesselInfoFromPCS(details) {
    return this.http.post(`${this.domain}container/getContainerVesselInfoFromPCS`, details, this.createAuthenticationHeaders())
  }

  getVehicleDetailsUsingFastag(details) {
    return this.http.post(`${this.domain}container/getVehicleDetailsUsingFastag`, details, this.createAuthenticationHeaders())
  }

  getContainerVaahanDetails(details) {
    return this.http.post(`${this.domain}container/getContainerVehicleDetails`, details, this.createAuthenticationHeaders())
  }

  // #endregion ThirdParty



  // #region Alerts
  private sessionExpiredShown = false;
  error: (error: any) => void = (e) => {
    console.log(e);

    const { status, statusText, _body, message } = e;
    if (_body) {
      if (_body == 'Unauthorized') {
        if (!this.sessionExpiredShown) {
          this.sessionExpiredShown = true; // Prevent multiple alerts
          this.showToast('error', "Session Expired! Please login again");
          this.logout();

          // Reset flag after a short delay to allow re-authentication attempts
          setTimeout(() => this.sessionExpiredShown = false, 3000);
        }
      }
      else {
        if (_body.type == "error") {
          this.showToast('error', "Connection Failed")
        }
        else {
          var err = JSON.parse(_body)
          this.showToast('error', err.message)
        }
      }
    }
    else {
      this.showToast('error', 'Try again later or Contact System Administrator')
    }
  };

  alert(res, msg) {

  }

  alertWithMessage(res, msg, msgData) {
    // if (res.message == "No Token Provided" || res.message == "Token Invalid Error" || res.message.includes("Session Expired")) {
    //   swal.fire({
    //     title: 'Sorry!',
    //     text: "Sesion Expired.",
    //     icon: 'error',
    //     showCancelButton: false,
    //     allowOutsideClick: false,
    //     confirmButtonColor: '#3085d6',
    //     confirmButtonText: 'Login again'
    //   }).then((result) => {
    //     if (result.value) {
    //       authToken = null;
    //       window.location.reload();
    //       localStorage.removeItem('key');;
    //       this.router.navigate([''])
    //     }
    //   })
    // }
    // else {
    //   if (msg) {
    //     swal.fire('Sorry', msgData, 'error');
    //   }
    // }
  }

  showToast(type: String, message: String) {
    notifier.show(type.toUpperCase(), message, type.toLowerCase() == 'error' ? 'danger' : type.toLowerCase(), '', 5000);
  }

  base64Convert(files) {
    return new Promise((resolve, reject) => {
      var fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result)
      };
      fr.onerror = (error) => {
        reject('Error: ' + error);
      };
      fr.readAsDataURL(files[0]);
    });
  }

  downloadImage(d, fileName) {
    fetch(d.image)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], d.ext)
        download(file, fileName, d.ext);
      })
  }

  detectFormChanges(form) {
    form.statusChanges.subscribe(validity => {
      switch (validity) {
        case "VALID":
          // do 'form valid' action
          break;
        case "INVALID":
          formValidity();
          break;
      }

      formValidity();
    })
  }

  resetVormValidity(form) {
    resetVormValidity()
  }
  // #endregion Alerts

  // socket: Socket;
  // observer: Observer<any>;
  // getSocketData() : Observable<any>
  // {
  //   this.socket = socketIo();

  //   this.socket.on('data', (res) =>
  //   {
  //     this.observer.next(res.data);
  //   });

  //   return this.createObservable();
  // }

  // createObservable() : Observable<number>
  // {
  //     return new Observable<number>(observer =>
  //     {
  //       this.observer = observer;
  //     });
  // }

  // private handleError(error) {
  //   console.error('server error:', error);
  //   if (error.error instanceof Error) {
  //       let errMessage = error.error.message;
  //       return Observable.throw(errMessage);
  //   }
  //   return Observable.throw(error || 'Socket.io server error');
  // }
}


function formValidity() {
  var forms = document.getElementsByClassName('needs-validation');
  Array.prototype.filter.call(forms, function (form) {
    form.classList.add('was-validated');
  });
}

function resetVormValidity() {
  var forms = document.getElementsByClassName('needs-validation');
  Array.prototype.filter.call(forms, function (form) {
    form.classList.remove('was-validated');
  });
}

function jqueryFns() {
  $(document).ready(function () {
    // App.init();
  });
}